// Conversation page
import './messages_page.less';

import * as Business                  from '../business';
import * as ContactsActions           from '../contacts/actions';
import * as ContactsChannels          from '../contacts/channels';
import * as ConversationsActions      from '../conversations/actions';
import * as ConversationsSelectors    from '../conversations/selectors';
import * as ENV                       from '../util/env';
import * as MessagesQueueActions      from '../messages_queue/actions';
import * as MessagesQueueSelectors    from '../messages_queue/selectors';
import * as UI                        from '../ui';
import * as User                      from '../user';
import { addTeamNamesToConversation } from './conversation_list';
import { Assignee }                   from './conversation_item';
import { callCustomer }               from '../call';
import { compose }                    from 'redux';
import { connect }                    from 'react-redux';
import { customerHasNpsScore }        from './conversation_item';
import { customerIsLead }             from './conversation_item';
import { Following }                  from './conversation_item';
import { openExternalLink }           from '../components/link';
import { useEffect }                  from 'react';
import { useState }                   from 'react';
import Activities                     from './activities';
import classnames                     from 'classnames';
import Dropdown                       from '../components/dropdown';
import FetchFromServer                from '../components/fetch_from_server';
import isCustomerBlocked              from '../contacts/is_customer_blocked';
import LeadBadge                      from './lead_badge';
import Link                           from '../components/link';
import logEvent                       from '../app/events/amplitude_log_event';
import MessageBar                     from '../components/message_bar';
import Navbar                         from '../components/navbar';
import NpsBadge                       from './nps_badge';
import RatingBadge                    from './rating_badge';
import React                          from 'react';
import ThumbBadge                     from './thumb_badge';
import useDialog                      from '../hooks/use_dialog';
import uuidv4                         from 'uuid/v4';

import { ExternalLink }               from 'react-feather';
import { Eye as FollowIcon }          from 'react-feather';
import { MoreVertical as MoreIcon }   from 'react-feather';
import { PhoneCall as PhoneIcon }     from 'react-feather';
import { EyeOff as UnfollowIcon }     from 'react-feather';
import AddNoteIcon                    from '../assets/icons/add_note.svg';
import AssignIcon                     from '../assets/icons/assign.svg';
import ContactInfoIcon                from '../contacts/contact_info_icon';
import MarkAsUnreadIcon               from './mark_as_unread_icon.svg';
import Note                           from './note';


export class MessagesPage extends React.Component {

  constructor(props) {
    super(props);

    this.onHeightChange                 = this.onHeightChange.bind(this);
    this.scrollToBottom                 = this.scrollToBottom.bind(this);
    this.addMessageToQueue              = this.addMessageToQueue.bind(this);
    this.retrySendMessage               = this.retrySendMessage.bind(this);
    this.handleMarkAsUnread             = this.handleMarkAsUnread.bind(this);
    this.handleFollow                   = this.handleFollow.bind(this);
    this.handleUnfollow                 = this.handleUnfollow.bind(this);
    this.handleNoteStartEditing         = this.handleNoteStartEditing.bind(this);
    this.handleNoteSave                 = this.handleNoteSave.bind(this);
    this.handleNoteDoneEditing          = this.handleNoteDoneEditing.bind(this);
    this.handleSendThankYouMessage      = this.handleSendThankYouMessage.bind(this);
    this.handleOpenInIntegrationWebsite = this.handleOpenInIntegrationWebsite.bind(this);
    this.onRouteChange                  = this.onRouteChange.bind(this);
    this.getConversation                = this.getConversation.bind(this);
    this.activitiesRef                  = React.createRef();

    this.state = {
      markedAsUnread:        false,
      note:                  { editing: false },
      isCurrentConversation: this.isCurrentConversation()
    };
  }

  onHeightChange() {
    this.scrollToBottom();
  }

  scrollToBottom() {
    if (this.activitiesRef && this.activitiesRef.current)
      this.activitiesRef.current.scrollToBottom();
  }

  addMessageToQueue({ attachments, body }) {
    const { conversation } = this.props;
    const [ customer ]     = conversation.customers;
    const { businessID }   = this.props;

    this.props.addMessageToQueue({
      attachments,
      body,
      businessID,
      customer: {
        ...customer,
        conversation: {
          id: conversation.id
        }
      }
    });
  }

  async handleSendThankYouMessage({ clientID }) {
    const { businessID }          = this.props;
    const { conversation }        = this.props;
    const conversationID          = conversation.id;
    const [ customer ]            = conversation.customers;
    const { sendThankYouMessage } = this.props;

    return await sendThankYouMessage({ customerID: customer.id, clientID, conversationID, businessID });
  }

  async handleMarkAsUnread() {
    const { markConversationAsUnread } = this.props;
    const { businessID }               = this.props;
    const { conversation }             = this.props;
    const { activities }               = this.props;
    const { navigateBackTo }           = this.props;
    const { isSplitView }              = this.props;

    const incomingMessages    = activities?.filter(({ type }) => type === 'IncomingMessage');
    const lastIncomingMessage = incomingMessages?.pop();
    const messageTimestamp    = lastIncomingMessage?.timestamp;

    if (messageTimestamp) {
      const ms         = Date.parse(messageTimestamp);
      const unreadDate = new Date(ms - 1);
      const timestamp  = unreadDate.toISOString();

      this.setState({
        markedAsUnread: true
      });

      if (!isSplitView)
        navigateBackTo(`/${businessID}/inbox`);

      await markConversationAsUnread({ conversation, timestamp });
    }
  }

  async handleFollow() {
    const { followConversation } = this.props;
    const { conversationID }     = this.props;
    const { businessID }         = this.props;

    await followConversation({ conversationID, businessID });
  }

  handleNoteStartEditing() {
    this.setState({ note: { editing: true } });
  }

  async handleNoteSave(noteBody) {
    const { businessID }             = this.props;
    const { updateConversationNote } = this.props;
    const { conversation }           = this.props;
    const { conversationID }         = this.props;

    const { note }    = conversation;
    const noteChanged = note?.body !== noteBody;
    if (conversationID && noteChanged) {
      await updateConversationNote({ conversationID, businessID, body: noteBody });
      this.setState({ note: { editing: false } });
    }
  }

  handleNoteDoneEditing() {
    const { conversation } = this.props;
    const note             = conversation?.note;
    const noteBody         = note?.body ?? '';
    const isNoteEmpty      = !noteBody.trim();

    this.setState({ note: { editing: !isNoteEmpty } });
  }

  async handleUnfollow() {
    const { businessID }           = this.props;
    const { unfollowConversation } = this.props;
    const { conversationID }       = this.props;

    await unfollowConversation({ conversationID, businessID });
  }

  retrySendMessage(messageId) {
    const { conversation }         = this.props;
    const customerID               = conversation.customer?.id;
    const { updateMessagesStatus } = this.props;

    return function() {
      updateMessagesStatus([ messageId ], customerID, 'inQueuePending');
    };
  }

  async handleOpenInIntegrationWebsite() {
    const { conversation }      = this.props;
    const { getIntegrationURL } = this.props;
    const customerID            = conversation.customer.id;
    const url                   = await getIntegrationURL({ customerID });

    openExternalLink(url);
  }

  componentDidMount() {
    const { f7router } = this.props;
    f7router.on('routeChange', this.onRouteChange);

    window.addEventListener('keyboardDidShow', this.scrollToBottom);
    window.addEventListener('keyboardDidHide', this.scrollToBottom);
  }

  componetWillUnmount() {
    const { f7router } = this.props;
    f7router.off('routeChange', this.onRouteChange);

    window.removeEventListener('keyboardDidShow', this.scrollToBottom);
    window.removeEventListener('keyboardDidHide', this.scrollToBottom);
  }

  onRouteChange() {
    const { markedAsUnread }    = this.state;
    const isCurrentConversation = this.isCurrentConversation();

    // when isCurrentConversation changes, we need to re-render
    this.setState({ isCurrentConversation });

    // if they mark as unread and then change to a different conversation, we want to
    // set markedAsUnread to false
    if (markedAsUnread && !isCurrentConversation)
      this.setState({ markedAsUnread: false });
  }

  isCurrentConversation() {
    const { f7router }          = this.props;
    const { conversationID }    = this.props;
    const currentConversationID = f7router.currentRoute.params?.conversationID;
    const isCurrentConversation = currentConversationID === conversationID;
    return isCurrentConversation;
  }

  getConversation() {
    const { conversation } = this.props;
    const { team }         = this.props;
    return conversation && addTeamNamesToConversation(conversation, team);
  }

  /* eslint-disable max-statements */
  render() {
    const { activities }                     = this.props;
    const { businessID }                     = this.props;
    const { business }                       = this.props;
    const { conversationID }                 = this.props;
    const { user }                           = this.props;
    const { team }                           = this.props;
    const { isAdmin }                        = this.props;
    const { isManager }                      = this.props;
    const { currentUserID }                  = this.props;
    const { load }                           = this.props;
    const { localFiles }                     = this.props;
    const { callSettings }                   = this.props;
    const { paymentsSettings }               = this.props;
    const { statuses }                       = this.props;
    const { markConversationAsRead }         = this.props;
    const { markedAsUnread }                 = this.state;
    const { isCurrentConversation }          = this.state;
    const { handleSendThankYouMessage }      = this;
    const { handleMarkAsUnread }             = this;
    const { handleFollow }                   = this;
    const { handleUnfollow }                 = this;
    const { handleNoteStartEditing }         = this;
    const { handleNoteSave }                 = this;
    const { handleNoteDoneEditing }          = this;
    const { handleOpenInIntegrationWebsite } = this;

    const conversation = this.getConversation();
    const [ customer ] = conversation?.customers ?? [];

    const isPaymentsAvailable = paymentsSettings?.available;
    const isPaymentsEnabled   = paymentsSettings?.enabled;
    const isPaymentsLiveMode  = paymentsSettings?.liveMode;

    const participants            = conversation?.participants ?? [];
    const assignees               = conversation?.assignees ?? [];
    const isAssignDisabled        = !isManager;
    const isFollowingConversation = participants.some(p => p.user.id === currentUserID);
    const isFollowingEnabled      = assignees.every(p => p.user.id !== currentUserID);

    const note          = conversation?.note ?? {};
    const noteBody      = note.body || '';
    const isNoteEmpty   = !noteBody.trim();
    const isNoteVisible = !isNoteEmpty || this.state.note.editing;

    const messageEnabled = isMessageEnabled(customer);
    const channel        = ContactsChannels.getPreferredChannel(customer);
    const placeholder    = customer && `Reply to ${customer.name.full} via ${channel}`;

    const maxSMSLength        = 1600;
    const maxBytes            = channel === 'SMS' ? maxSMSLength : Infinity;
    const shoudlReload        = conversation && !activities;
    const shouldMarkAsRead    = conversation && activities && isCurrentConversation && !markedAsUnread;
    const incomingMessages    = activities?.filter(({ type }) => type === 'IncomingMessage');
    const lastIncomingMessage = incomingMessages?.pop();

    return (
      <React.Fragment>
        <Navbar title={customer?.name.full} className="messages-page-navbar">
          {conversation && (
            <Navbar.RightButton>
              <CallButton {...{ business, conversation, callSettings, user }}/>
              <CustomerNavDropdown {...{
                businessID,
                conversationID,
                customer,
                handleNoteStartEditing,
                handleFollow,
                handleMarkAsUnread,
                handleUnfollow,
                isAssignDisabled,
                isFollowingConversation,
                isFollowingEnabled,
                isAddNoteEnabled: isNoteEmpty,
                lastIncomingMessage,
                markedAsUnread,
                handleOpenInIntegrationWebsite
              }}/>
            </Navbar.RightButton>
          )}
        </Navbar>

        <MessageBar
          businessID={businessID}
          leftButtons={<MessageBarLeftButtons {...{ business, isPaymentsAvailable, isPaymentsEnabled, isAdmin, isPaymentsLiveMode, conversation, handleSendThankYouMessage }}/>}
          disabledPlaceholder={<DisabledMessagebar {...{ businessID, conversation }}/>}
          enabled={messageEnabled}
          placeholder={placeholder}
          onHeightChange={this.onHeightChange}
          onSend={this.addMessageToQueue}
          maxBytes={maxBytes}
        >
          {({ showMessageBar, hideMessageBar }) => {
            function onNoteEdit() {
              if (ENV.isCordova())
                hideMessageBar();
            }

            function onNoteView() {
              if (ENV.isCordova())
                showMessageBar();
              handleNoteDoneEditing();
            }

            return (
              <FetchFromServer
                statuses={statuses}
                load={load}
                reload={shoudlReload}
                className="content-messages">
                {conversation && (
                  <ConversationInfo {...{ businessID, currentUserID, conversation }}/>
                )}
                {isNoteVisible && team && (
                  <Note
                    note={note}
                    team={team}
                    handleNoteSave={handleNoteSave}
                    onEdit={onNoteEdit}
                    onView={onNoteView}
                  />
                )}
                {activities && (
                  <Activities
                    localFiles={localFiles}
                    retrySendMessage={this.retrySendMessage}
                    conversation={conversation}
                    activities={activities}
                    business={business}
                    ref={this.activitiesRef}
                  />
                )}
                {shouldMarkAsRead && (
                  <MarkConversationAsRead {...{ conversation, activities, markConversationAsRead }}/>
                )}
              </FetchFromServer>
            );
          }}
        </MessageBar>
      </React.Fragment>
    );
  }
}


function CallButton({ business, conversation, callSettings, user }) {
  const toast              = UI.useToast();
  const [ customer ]       = conversation.customers;
  const { device }         = callSettings;
  const hasPhoneNumber     = !!(conversation?.contact.phone?.number);
  const canCallFromDesktop = !!(device === 'browser' && ENV.isWeb() && ENV.isWebRTCSupported());
  const canCallFromPhone   = !!(device === 'phone' && user.phone);
  const canMakeCalls       = (canCallFromDesktop || canCallFromPhone);
  const disabled           = (!hasPhoneNumber || !canMakeCalls);
  const className          = classnames('call-button', { disabled });

  function showDisabledMessage() {
    const noPhoneMessage = 'Sorry, we have no phone number for this customer.';
    const noCallsMessage = 'Sorry, you can’t make calls from this device.';
    const message        = hasPhoneNumber ? noCallsMessage : noPhoneMessage;
    toast(message);
  }

  function makeCall() {
    callCustomer({ customer, business });
    const amplitudeProps = customer && {
      businessID:     business.id,
      customerID:     customer.id,
      customerStatus: customer.status
    };
    logEvent('ClickedPhoneButton', amplitudeProps);
  }

  function onClick(event) {
    event.preventDefault();
    if (disabled)
      showDisabledMessage();
    else
      makeCall();
  }

  return (
    <div className={className} onClick={onClick}>
      <PhoneIcon/>
    </div>
  );
}

function CustomerNavDropdown({
  businessID,
  conversationID,
  customer,
  handleNoteStartEditing,
  handleFollow,
  handleMarkAsUnread,
  handleUnfollow,
  isAssignDisabled,
  isAddNoteEnabled,
  isFollowingConversation,
  isFollowingEnabled,
  lastIncomingMessage,
  markedAsUnread,
  handleOpenInIntegrationWebsite
}) {
  const markAsUnreadDisabled = (markedAsUnread || !lastIncomingMessage);
  const customerID           = customer?.id;

  const hasIntegration = customer?.source?.name && customer?.publicID && customer.publicID !== customerID;
  // We currently only support ShopWare in the "View in" integration.
  const hasShopWareIntegration = hasIntegration && customer?.source?.name === 'shopWare';

  return (
    <Dropdown className="customer-nav-dropdown">
      <Dropdown.Header>
        <MoreIcon/>
      </Dropdown.Header>
      <Dropdown.Content>
        <Dropdown.Item disabled={markAsUnreadDisabled} onClick={handleMarkAsUnread}>
          <span>
            <MarkAsUnreadIcon/>
            Mark as Unread
          </span>
        </Dropdown.Item>
        <Dropdown.Item disabled={isAssignDisabled}>
          <a href={`/${businessID}/inbox/${conversationID}/assign`}>
            <AssignIcon/>
              Assign
          </a>
        </Dropdown.Item>
        {isFollowingEnabled && !isFollowingConversation && (
          <Dropdown.Item onClick={handleFollow}>
            <span>
              <FollowIcon strokeWidth="1"/>
                Follow
            </span>
          </Dropdown.Item>
        )}
        {isFollowingEnabled && isFollowingConversation && (
          <Dropdown.Item onClick={handleUnfollow}>
            <span>
              <UnfollowIcon strokeWidth="1"/>
                Unfollow
            </span>
          </Dropdown.Item>
        )}
        {isAddNoteEnabled && (
          <Dropdown.Item onClick={handleNoteStartEditing}>
            <span>
              <AddNoteIcon/>
              Add Note
            </span>
          </Dropdown.Item>
        )}
        <Dropdown.Item>
          <a href={`/${businessID}/contacts/${customerID}`}>
            <ContactInfoIcon/>
            Contact Info
          </a>
        </Dropdown.Item>
        {hasShopWareIntegration && (<Dropdown.Item onClick={handleOpenInIntegrationWebsite}>
          <span>
            <ExternalLink/>
            View in Shop-Ware
          </span>
        </Dropdown.Item>
        )}
      </Dropdown.Content>
    </Dropdown>
  );
}


function MarkConversationAsRead({ conversation, activities, markConversationAsRead }) {
  useEffect(function() {
    const conversationID = conversation?.id;
    const unreadCount    = conversation?.unreadCount ?? 0;
    const lastActivity   = activities[activities.length - 1];
    const timestamp      = lastActivity?.timestamp;

    if (conversationID && unreadCount > 0)
      markConversationAsRead({ conversation, timestamp });

  }, [ activities, conversation, markConversationAsRead ]);

  return null;
}


function ConversationInfo({ businessID, currentUserID, conversation }) {
  return (
    <div className="conversation-info">
      <CustomerStatus {...{ businessID, conversation }}/>
      <UserStatus {...{ currentUserID, conversation }}/>
    </div>
  );
}

function CustomerStatus({ businessID, conversation }) {
  const classify = Business.useClassifySetting(businessID);
  const isNPS    = (classify === 'nps');

  const [ customer ]  = conversation.customers;
  const isLead        = customerIsLead(customer);
  const hasNpsScore   = isNPS && customerHasNpsScore(customer);
  const review        = getLatestReview(customer);
  const hasThumbsUp   = !isNPS && customer.promoter === true;
  const hasThumbsDown = !isNPS && customer.promoter === false;

  return (
    <div className="customer-status">
      {isLead &&        <LeadBadge/>}
      {hasNpsScore &&   <NpsBadge score={customer.npsScore}/>}
      {review &&        <RatingBadge {...review}/>}
      {hasThumbsUp &&   <ThumbBadge type="up"/>}
      {hasThumbsDown && <ThumbBadge type="down"/>}
    </div>
  );
}


function getLatestReview(customer) {
  const reviews = customer?.reviews || {};

  const list = Object.keys(reviews).map(platform => {
    const review = customer.reviews[platform];
    return {
      platform,
      ...review
    };
  });

  list.sort(sortReviewsByDate);

  return list[0];
}

function sortReviewsByDate(a, b) {
  const aPublished = a.published || 0;
  const bPublished = b.published || 0;
  const aTime      = Date.parse(aPublished);
  const bTime      = Date.parse(bPublished);
  return bTime - aTime;
}


function UserStatus({ currentUserID, conversation }) {
  return (
    <div className="user-status">
      <Following {...{ conversation, currentUserID }}/>
      <Assignee {...{ conversation, currentUserID }}/>
    </div>
  );
}


function MessageBarLeftButtons({ conversation, business, isPaymentsAvailable, isPaymentsEnabled, isAdmin, isPaymentsLiveMode, handleSendThankYouMessage }) {
  const [ customer ]              = conversation?.customers ?? [];
  const showPaymentsRequestButton = isPaymentsAvailable && isPaymentsEnabled && customer && (isPaymentsLiveMode || isAdmin);

  return (
    <React.Fragment>
      {showPaymentsRequestButton && <PaymentRequestButton customerID={customer?.id} businessID={business.id}/>}
      {customer && <ReviewRequestButton {...{ customer, handleSendThankYouMessage }}/>}
    </React.Fragment>
  );
}

function PaymentRequestButton({ businessID, customerID }) {
  return (
    <a className="link icon-only" href={`/${businessID}/contacts/${customerID}/invoice`}>
      <i className="icon icons8 icons8-requested-payment"/>
    </a>
  );
}


export function ReviewRequestButton({ customer, handleSendThankYouMessage }) {
  const [ clientID, setClientID ] = useState(uuidv4());

  async function onClick() {
    await handleSendThankYouMessage({ clientID });
    // Generate new client ID after each successful send.
    setClientID(uuidv4());
  }

  const buttons = [ // options for the buttons in the dialog
    {
      text:  'Cancel',
      color: 'blue',
      close: true
    },
    {
      text:  'Send',
      close: true,
      bold:  true,
      onClick
    }
  ];

  const onIconClick = useDialog({
    title:   'Send a review request',
    content: `Send a review request to ${customer.name.full}?`,
    buttons
  });

  return (
    <div className="link icon-only">
      <i className="icon icons8 icons8-very-popular-topic" onClick={onIconClick} title="Send Review Request"></i>
    </div>
  );
}


function isMessageEnabled(customer) {
  const hasChannel = customer && ContactsChannels.hasAvailable(customer);
  const isBlocked  = customer && isCustomerBlocked(customer);
  return (hasChannel && !isBlocked);
}


function DisabledMessagebar({ businessID, conversation }) {
  const [ customer ] = conversation?.customers ?? [];
  const hasNoChannel = customer && !ContactsChannels.hasAvailable(customer);
  const isBlocked    = customer && isCustomerBlocked(customer);

  if (hasNoChannel)
    return <NoChannelMessagebar/>;
  else if (isBlocked)
    return <BlockedMessagebar {...{ businessID, customer }}/>;
  else
    return <EmptyMessageBar/>;
}


function NoChannelMessagebar() {
  return (
    <div className="messagebar__disabled-info">
      <i className="icons8 icons8-info"/>
      <p>No email or SMS number. Add an email address or SMS-enabled phone number for this contact to send a message.</p>
    </div>
  );
}


function BlockedMessagebar({ businessID, customer }) {
  const customerID = customer?.id;
  return (
    <div className="messagebar__disabled-info">
      <i className="icons8 icons8-info"/>
      <p>
        This customer has been blocked. To send a message, <Link href={`/${businessID}/contacts/${customerID}`}>unblock this customer</Link>.
      </p>
    </div>
  );
}


function EmptyMessageBar() {
  return (
    <div style={{ height: '91px' }}/>
  );
}


export default connect(
  (state, { businessID, conversationID }) => ({
    businessID,
    conversationID,
    business:         Business.getBusiness(state, businessID),
    paymentsSettings: Business.getPaymentsSettings(state, businessID),
    statuses:         ConversationsSelectors.getConversationStatuses(state, conversationID),
    conversation:     ConversationsSelectors.getConversation(state, conversationID),
    currentUserID:    User.getUserID(state),
    activities:       ConversationsSelectors.getActivitiesWithPendingQueue(state, conversationID),
    localFiles:       MessagesQueueSelectors.getLocalFiles(state),
    user:             User.getProfile(state),
    callSettings:     User.getCallSettings(state),
    isAdmin:          User.isAdmin(state, businessID),
    isManager:        User.isManager(state, businessID),
    team:             Business.getTeam(state, businessID)
  }),
  (dispatch, { businessID, conversationID }) => ({
    load:                     () => dispatch(ConversationsActions.readConversation({ conversationID, businessID })),
    addMessageToQueue:        compose(dispatch, MessagesQueueActions.addMessageToQueue),
    updateMessagesStatus:     compose(dispatch, MessagesQueueActions.updateMessagesStatus),
    sendThankYouMessage:      compose(dispatch, ContactsActions.sendThankYouMessage),
    getIntegrationURL:        compose(dispatch, ContactsActions.getIntegrationURL),
    markConversationAsRead:   compose(dispatch, ConversationsActions.markConversationAsRead),
    markConversationAsUnread: compose(dispatch, ConversationsActions.markConversationAsUnread),
    unfollowConversation:     compose(dispatch, ConversationsActions.unfollowConversation),
    followConversation:       compose(dispatch, ConversationsActions.followConversation),
    updateConversationNote:   compose(dispatch, ConversationsActions.updateConversationNote)
  })
)(MessagesPage);
